import { VariantProps, tv } from 'tailwind-variants'
import { DayPicker } from 'react-day-picker'
import { ptBR } from 'date-fns/locale'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { Typography } from '../Typography'

import { CustomCaption, formatWeekdayName } from './components/Caption'
import { format } from 'date-fns'

const tvInputDate = tv({
  slots: {
    input: 'relative h-10 bg-gray-800 rounded-md px-3  w-full text-left',
    text: 'text-gray-400',
  },
  variants: {
    hasValue: {
      true: {
        text: 'text-gray-200',
      },
    },
    isDisabled: {
      true: {
        input: 'opacity-50',
      },
    },
    isInvalid: {
      true: {
        input:
          'border-danger-500 border  shadow-danger-500 shadow-sm focus-visible:outline-danger-500 border-opacity-100',
      },
    },
  },
})

function formatDateDescribe(date: Date) {
  return format(date, `dd MMM'.'yyyy`, { locale: ptBR })
}

type TInputDate = {
  value?: string
  placeholder: string
  onChange: (value?: string) => void
  message?: string
} & VariantProps<typeof tvInputDate>

export function InputDate({
  value,
  placeholder,
  onChange,
  isDisabled = false,
  isInvalid = false,
  message,
}: TInputDate) {
  const { input, text } = tvInputDate({
    hasValue: !!value,
    isDisabled,
    isInvalid,
  })

  const parsedValue = value ? new Date(value) : new Date()

  const describedDate = value ? formatDateDescribe(parsedValue) : placeholder

  return (
    <div className="flex flex-col">
      <Popover className="relative">
        <PopoverButton className={input()} disabled={isDisabled}>
          <Typography type="bodyOne" className={text()}>
            {describedDate}
          </Typography>
        </PopoverButton>

        <PopoverPanel>
          {({ close }) => (
            <div className="absolute top-12 z-10">
              <DayPicker
                locale={ptBR}
                mode="single"
                showOutsideDays
                components={{
                  MonthCaption: CustomCaption,
                }}
                selected={parsedValue}
                defaultMonth={parsedValue}
                hideNavigation
                formatters={{ formatWeekdayName }}
                onSelect={(selected) => {
                  selected && onChange(format(selected, 'yyyy-MM-dd'))

                  close()
                }}
              />
            </div>
          )}
        </PopoverPanel>
      </Popover>
      {message && (
        <Typography type="caption" className="text-danger-500">
          {message}
        </Typography>
      )}
    </div>
  )
}
